export default __webpack_public_path__ + "static/media/sign-up-img.2600a248.png";